module.exports = __webpack_public_path__ + "img/Frame-5.svg";